module.exports = __webpack_public_path__ + "img/rjmt_round.d60171d6.png";